import React from 'react';
import { motion } from 'framer-motion';
import { Briefcase, Plane, GlassWater, Crown } from 'lucide-react';
const services = [{
  icon: Briefcase,
  title: '商务伴游',
  sub: 'Business Companion',
  desc: 'Professional etiquette for high-end business functions and dinners.'
}, {
  icon: Plane,
  title: '旅行伴游',
  sub: 'Travel Companion',
  desc: 'Perfect company for your Singapore exploration or island getaways.'
}, {
  icon: GlassWater,
  title: '私人派对',
  sub: 'Private Events',
  desc: 'Charismatic presence for private parties and social gatherings.'
}, {
  icon: Crown,
  title: '定制服务',
  sub: 'Custom Experience',
  desc: 'Tailored arrangements to meet your specific preferences and needs.'
}];
export function Services() {
  return <section id="services" className="py-24 bg-dark-800 relative overflow-hidden" data-id="element-276">
      {/* Decorative Background */}
      <div className="absolute top-0 right-0 w-1/3 h-full bg-gradient-to-l from-white/[0.02] to-transparent pointer-events-none" data-id="element-277"></div>

      <div className="max-w-7xl mx-auto px-6 relative z-10" data-id="element-278">
        <div className="text-center mb-20" data-id="element-279">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-5xl font-serif text-white mb-4" data-id="element-280">
            尊享<span className="text-gold-500" data-id="element-281">服务</span>
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-gold-500/60 uppercase tracking-[0.2em] text-sm" data-id="element-282">
            Premium Services
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-white/5 border border-white/5" data-id="element-283">
          {services.map((service, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-dark-800 p-12 group hover:bg-white/[0.02] transition-colors duration-500 relative overflow-hidden" data-id="element-284">
              <div className="absolute top-0 right-0 p-6 opacity-10 group-hover:opacity-20 transition-opacity duration-500 transform group-hover:scale-110 group-hover:rotate-12" data-id="element-285">
                <service.icon size={120} data-id="element-286" />
              </div>

              <div className="relative z-10" data-id="element-287">
                <div className="w-12 h-12 rounded-full border border-gold-500/30 flex items-center justify-center mb-8 group-hover:bg-gold-500 group-hover:border-gold-500 transition-all duration-500" data-id="element-288">
                  <service.icon className="w-5 h-5 text-gold-500 group-hover:text-dark-900 transition-colors" data-id="element-289" />
                </div>

                <h3 className="text-2xl font-serif text-white mb-2" data-id="element-290">
                  {service.title}
                </h3>
                <h4 className="text-xs text-gold-500/70 uppercase tracking-widest mb-6" data-id="element-291">
                  {service.sub}
                </h4>
                <p className="text-gray-500 leading-relaxed max-w-sm" data-id="element-292">
                  {service.desc}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}